import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../components/ui/Card';
import AppIcon from '../../../components/AppIcon';
import { PageLayout } from '../../../components/ui/PageLayout';
import { PieChart } from 'lucide-react';

const reportCards = [
    { to: '/attendance/reports/clockings', icon: 'Clock' as const, labelKey: 'Clockings' },
    { to: '/attendance/reports/shifts', icon: 'CalendarDays' as const, labelKey: 'Shifts' },
    { to: '/attendance/reports/overtime', icon: 'Timer' as const, labelKey: 'Overtime' },
    { to: '/attendance/reports/work-sessions', icon: 'Briefcase' as const, labelKey: 'Work Sessions' },
    { to: '/attendance/reports/out-of-bounds', icon: 'MapPinOff' as const, labelKey: 'Out of bounds' },
];

export default function Reports() {
    const { t } = useTranslation();
    const companyPrimaryColor = useSelector(
        (state: any) => state.user.companyPrimaryColor,
    );
    const brandColor = companyPrimaryColor || 'var(--mowazaf-primary)';

    return (
        <PageLayout
            title={t('Reports')}
            description={t('Explore and download attendance-related reports.')}
            icon={PieChart}
            accentColor="blue"
            maxWidth="1600px"
        >
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {reportCards.map((card) => (
                    <Card key={card.to} variant="interactive" className="h-full">
                        <RouterLink
                            to={card.to}
                            aria-label={t(`Open ${card.labelKey} report`)}
                            className="flex flex-col items-center gap-2 p-6 no-underline"
                        >
                            <AppIcon
                                name={card.icon}
                                size={28}
                                style={{ color: brandColor }}
                            />
                            <span className="font-semibold text-foreground">
                                {t(card.labelKey)}
                            </span>
                        </RouterLink>
                    </Card>
                ))}
            </div>
        </PageLayout>
    );
}
